
<table class="prom-list" aria-describedby={aria_describedby}>
    <slot name="header" />
    <slot name="body" />
</table>

<script>
    export let aria_describedby = undefined;
</script>
